import Vue from 'vue'
import VueRouter from 'vue-router'
import LayoutVue from "@/layout/index.vue"
import store from "@/store"

Vue.use(VueRouter)

const routes = [
  {
    path: "/home",
    name: "home",
    meta: {
      title: "首页",
      hideInMenu: true
    },
    component: () => import("@/views/home/index.vue")
    // component: () => import("@/pages/ht/login.vue")
  },
  {
    path: '/',
    name: 'Layout',
    component: LayoutVue,
    redirect: '/home',
    children: [
      //   {
      //   path: 'home',
      //   name: 'home',
      //   meta: {
      //     title: '首页',
      //     requireAuth: false
      //   },
      //   component: () => import('@/views/home/index.vue')
      // }, 
      {
        path: 'competitionGuide',
        name: 'competitionGuide',
        meta: {
          title: '竞赛指南',
          requireAuth: false
        },
        component: () => import('@/views/competitionGuide/index.vue')
      },  {
        path: 'listOfWinners',
        name: 'listOfWinners',
        meta: {
          title: '获奖名单',
          requireAuth: true
        },
        component: () => import('@/views/listOfWinners/index.vue')
      }, {
        path: 'organizationalStructure',
        name: 'organizationalStructure',
        meta: {
          title: '组织机构',
          requireAuth: false
        },
        component: () => import('@/views/organizationalStructure/index.vue')
      }, {
        path: 'competitionGuide/detail/:id',
        name: 'competitionGuideDetail',
        meta: {
          activePath: '/competitionGuide',
          title: '新闻详情',
          requireAuth: false
        },
        component: () => import('@/views/competitionGuide/detail.vue')
      }, {
        path: 'academicActivities',
        name: 'academicActivities',
        meta: {
          title: '学术活动',
          requireAuth: false
        },
        component: () => import('@/views/academicActivities/index.vue')
      }, {
        path: 'researchFindings',
        name: 'researchFindings',
        meta: {
          title: '研究成果',
          requireAuth: false
        },
        component: () => import('@/views/researchFindings/index.vue')
      }, {
        path: 'sciencePopularizationActivities',
        name: 'sciencePopularizationActivities',
        meta: {
          title: '科普活动',
          requireAuth: false
        },
        component: () => import('@/views/sciencePopularizationActivities/index.vue')
      }, {
        path: 'societyMembers',
        name: 'societyMembers',
        meta: {
          title: '学会成员',
          requireAuth: false
        },
        component: () => import('@/views/societyMembers/index.vue')
      }, {
        path: 'aboutUs',
        name: 'aboutUs',
        meta: {
          title: '关于我们',
          requireAuth: false
        },
        component: () => import('@/views/aboutUs/index.vue')
      }, {
        path: 'contactUs',
        name: 'contactUs',
        meta: {
          title: '联系我们',
          requireAuth: false
        },
        component: () => import('@/views/contactUs/index.vue')
      }, {
        path: 'honor',
        name: 'honor',
        meta: {
          title: '学会荣誉',
          requireAuth: false
        },
        component: () => import('@/views/honor/index.vue')
      }]
  }
]
const router = new VueRouter({
  routes,
  scrollBehavior: () => ({ y: 0, smooth: true }),
  mode: 'history'
})

// 防止连续点击多次路由报错
let routerPush = VueRouter.prototype.push;
let routerReplace = VueRouter.prototype.replace;
// push
VueRouter.prototype.push = function push(location) {
  return routerPush.call(this, location).catch(err => err)
}
// replace
VueRouter.prototype.replace = function push(location) {
  return routerReplace.call(this, location).catch(err => err)
}


export default router
